import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.13 12c1.032 0 1.885-.843 1.724-1.863a12 12 0 0 0-9.99-9.991C12.842-.014 12 .838 12 1.87s.848 1.85 1.855 2.082a8.26 8.26 0 0 1 6.192 6.192C20.28 11.152 21.096 12 22.13 12"
    }, null, -1),
    _createElementVNode("animateTransform", {
      attributeName: "transform",
      dur: "1.5s",
      from: "0 0 0",
      repeatCount: "indefinite",
      to: "360 0 0",
      type: "rotate"
    }, null, -1)
  ])))
}
export default { render: render }